import React, { useState, useEffect, useRef } from "react";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../components/common/Title/Title";
import { TiUser } from "react-icons/ti";
import { Button } from "react-bootstrap";
import {
  customerTypeOptions,
  initFilterInput,
  renderColumns,
} from "./constants";
import CustomTable from "../../../components/common/Table/CustomTable";
import { convertOutletList, convertCustomerList } from "../helpers/index";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import Cookies from "js-cookie";
import httpclient from "../../../components/httpclient";
import TextInput from "../../../components/common/TextInput/TextInput";
import ModalEdit from "../components/ModalEdit";
import moment from "moment";
import SwalToast from "../../../components/helpers/SwalToast";
import IsEmpty from "../../../components/helpers/IsEmpty";
import MultipleSelect from "../../../components/common/MultipleSelect/MultipleSelect";
import ExportButton from "../../finance/components/ExportButton";
import qs from "qs";

export default function Customers() {
  const pageSizeRef = useRef();
  const searchNameRef = useRef();
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});
  const [customerList, setCustomerList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [modalEdit, setModalEdit] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [customerType, setCustomerType] = useState(customerTypeOptions[0]);

  // useEffect(() => {
  //   getOutlet();
  // }, []);

  useEffect(() => {
    getData();
  }, [filterInput]);

  // const getOutlet = () => {
  //   let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
  //   AxiosCustomGet(
  //     url,
  //     Config({
  //       Authorization: `Bearer ${Cookies.get("access_token")}`,
  //     }),
  //     (response) => {
  //       setOutletList(convertOutletList(response.data.data));
  //     }
  //   );
  // };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  const getData = () => {
    setLoading(true);
    let params = {
      page: filterInput.page,
      size: filterInput.pageSize,
      search: filterInput.searchName,
      has_transaction: filterInput.has_transaction,
      has_account: filterInput.has_account,
      is_agent: filterInput.is_agent,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer`;
    httpclient
      .GET(url, params)
      .then((res) => {
        let data = res.data.data;
        setCustomerList(convertCustomerList(res.data.data.items));
        setTablePagination({
          current: data?.page,
          pageSize: data?.per_page,
          total: data?.total_item,
        });
        setTotalRecords(data?.total_item);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelectChange = (field, value) => {
    let data = {
      ...filterInput,
      has_transaction: null,
      has_account: null,
      is_agent: null,
    };
    setCustomerType(value);
    if (value) {
      setFilterInput(() => ({
        ...data,
        [value.value]: true,
      }));
    }
  };

  const handleTextInput = (event) => {
    const { name, value } = event.target;

    setSelectedCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (event) => {
    setSelectedCustomer((prev) => ({
      ...prev,
      birthdate: event,
    }));
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;

      if (event.keyCode === 13 || type === "blur") {
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "searchName") {
      setFilterInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEdit = (record) => {
    setSelectedCustomer(record);
    setModalEdit(true);
  };
  const handleCloseModalEdit = () => {
    setSelectedCustomer({});
    setModalEdit(false);
    setErrors({});
  };

  const onSubmitEdit = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        ktp_picture: selectedCustomer.ktp,
        ktp_name: selectedCustomer.customerName,
        ktp_number: selectedCustomer.nik,
        province: selectedCustomer.province,
        city: selectedCustomer.city,
        subdistrict: selectedCustomer.subdistrict,
        village: selectedCustomer.village,
        address: selectedCustomer.address,
        gender: selectedCustomer.gender,
        birth_date: moment(selectedCustomer.birthdate).toDate(),
      };
      setLoading(true);
      let url = `${process.env.REACT_APP_BASE_API_URL}customer/${selectedCustomer.idCustomer}`;
      httpclient
        .PUT(url, data)
        .then((res) => {
          getData();
          setModalEdit(false);
          SwalToast.fire({
            icon: "success",
            title: res.data.message,
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (IsEmpty(selectedCustomer.customerName)) {
      newErrors.customerName = "Nama tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.nik)) {
      newErrors.nik = "NIK tidak boleh kosong";
    }
    if (!moment(selectedCustomer.birthdate).isValid()) {
      newErrors.birthdate = "Tanggal lahir tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.gender)) {
      newErrors.gender = "Jenis kelamin tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.address)) {
      newErrors.address = "Alamat tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.province)) {
      newErrors.province = "Provinsi tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.city)) {
      newErrors.city = "Kota tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.subdistrict)) {
      newErrors.subdistrict = "Kecamatan tidak boleh kosong";
    }
    if (IsEmpty(selectedCustomer.village)) {
      newErrors.village = "Kelurahan tidak boleh kosong";
    }
    return newErrors;
  };

  const resetFilter = () => {
    setFilterInput(initFilterInput);
    setCustomerType(customerTypeOptions[0]);
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  function filterNonNull(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
  }

  const handleExportExcel = () => {
    let data = {
      has_transaction: filterInput.has_transaction,
      has_account: filterInput.has_account,
      is_agent: filterInput.is_agent,
    };
    let filename = "daftar_nasabah.xlsx";
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-excel`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(filterNonNull(params), { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        console.log("handleExportExcel", error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  return (
    <div className="px-3">
      <div className="py-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Daftar Nasabah"} />
          <Breadcrumb current={"Daftar Nasabah"} />
        </div>
        <div className="d-flex">
          <div
            style={{
              display: "flex",
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              width: 222,
              // justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TiUser style={{ margin: 5, fontSize: 24, color: "#D6D6D6" }} />
            <div
              style={{
                fontSize: 18,
                color: "#303030",
              }}
            >
              <span style={{ fontWeight: 700 }}>{totalRecords}</span> Total
              Nasabah
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between filter-bar mb-4">
        <div className="d-flex  filter-bar-2">
          <TextInput
            id={"pageSize"}
            label="Tampilkan"
            handleEnter={handleEnter}
            value={filterInput.pageSize}
            handleChange={handleTextInputChange}
            width={68}
            ref={pageSizeRef}
          />
          <TextInput
            id={"searchName"}
            label="Nama Nasabah / No. KTP / Email"
            handleEnter={handleEnter}
            value={filterInput.searchName}
            handleChange={handleTextInputChange}
            width={310}
            placeholder={"Cari.."}
            ref={searchNameRef}
          />
          <MultipleSelect
            id={"customer_type"}
            label={"Jenis Nasabah"}
            onSelectChange={handleSelectChange}
            options={customerTypeOptions}
            width={200}
            placeholder="Jenis Nasabah"
            value={customerType}
          />
        </div>
        <div className="filter-bar">
          <Button
            variant="link"
            className="btn-action btn-reset"
            onClick={resetFilter}
          >
            Reset semua filter
          </Button>
        </div>
      </div>

      <CustomTable
        columns={renderColumns(handleEdit)}
        data={customerList}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />
      <ModalEdit
        handleInputChange={handleTextInput}
        modalEdit={modalEdit}
        handleClose={handleCloseModalEdit}
        submitting={submitting}
        onSubmitEdit={onSubmitEdit}
        data={selectedCustomer}
        handleDate={handleDateChange}
        errors={errors}
      />
      <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
        <ExportButton
          handleExport={handleExport}
          pathname="/report/customer/export"
          data={customerList}
          from="customer"
          columns={renderColumns(null, null)}
        />
      </div>
    </div>
  );
}
